module.exports = __webpack_public_path__ + "static/BACKGGROUND1-01-6cabeebf9a10b3b9cc05e79123192a32.png";